import { MaskedFunction } from 'imask';

export const textMask = () => {
  return {
    mask: new MaskedFunction<string>({ mask: (str: string) => String(str) }),
    lazy: false,
  };
};
